<button
  type="button"
  class="e-btn e-btn--icon touch-action-manipulation"
  aria-label="Zoom inn"
  title="Zoom inn"
  (click)="zoomIn()">
  <span class="e-btn__icon">
    <e-icon name="zoomIn" />
  </span>
</button>

<button
  type="button"
  class="e-btn e-btn--icon touch-action-manipulation"
  aria-label="Zoom ut"
  title="Zoom ut"
  (click)="zoomOut()">
  <span class="e-btn__icon">
    <e-icon name="zoomOut" />
  </span>
</button>
